import { Controller } from "stimulus"

export default class extends Controller
  doHighlight: ->
    $(@element).effect("highlight", {}, 1000)